package com.upcominds.expedite.model

import kotlinx.serialization.Serializable

@Serializable
enum class ChallengeType {
    PUZZLE,
    QUESTIONNAIRE,
    SAVINGS,
    SOCIAL_POST
}
